/* eslint-disable */

import request from '@/utils/request'

export function getListApi(query) {
  return request({
    url: '/config-service/v1/account/transaction-config',
    method: 'get',
    params: query
  })
}

export function getListMethodName(query) {
  return request({
    url: '/config-service/v1/account/transaction-config/method',
    method: 'get',
    params: query
  })
}
